export interface OptionsType {
  label: string;
  value: number | string;
  postType?: number | string;
}

export const getConvertedData = (data: any) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = item.name
        ? item.name
        : item.gradeName
        ? item.gradeName
        : item.nationalSalaryScale
        ? item.nationalSalaryScale
        : item.title
        ? item.title
        : `${item?.unit?.name || ""} ~ ${item?.position?.name || ""}`;

      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedUnitData = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = language === "bn" ? item.bnName : item.name;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedPositionData = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = language === "bn" ? item.nameBn : item.name;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedPositionDataWithPostType = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === "bn" ? item.position.nameBn : item.position.name;
      selectOptions.value = item.position.id;
      selectOptions.postType = item.postType;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedUnitPositionData = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === "bn"
          ? `${item?.unit?.bnName} ~ ${item?.position?.nameBn}`
          : `${item?.unit?.name} ~ ${item?.position?.name}`;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedGradeData = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === "bn" ? item.gradeNameBn : item.gradeName;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });
  return convertedData;
};

export const getConvertedOfficeAddress = (
  data: any,
  language: string | null | undefined,
) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === "bn"
          ? item.nameBn?.length > 0
            ? item.nameBn
            : item.name
          : item.name;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData;
};

export const getConvertedBudgetYearList = (data: any) => {
  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label = item.year;
      selectOptions.value = item.year;

      convertedData.push(selectOptions);
    });

  return convertedData;
};
